import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import './AlertPopup.css';
import Button from '../../../../../components/common/Button';

interface ModalProps {
  closeModal: (value: boolean) => void;
  showModal: boolean;
  title: any;
  buttonOneLabel?: string;
  buttonTwoLabel?: string;
}

const AlertPopup: React.FC<ModalProps> = ({
  closeModal,
  showModal,
  title,
  buttonOneLabel,
  buttonTwoLabel
}) => {
  const [show, setShow] = useState<boolean>(showModal);

  useEffect(() => {
    setShow(showModal);
  }, [showModal]);

  const closeYes = () => {
    closeModal(true);
  };

  const closeNo = () => {
    closeModal(false);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={closeNo}
        backdrop="static"
        keyboard={false}
        dialogClassName="custom_modal_page_close_button"
      >
        <Modal.Body className="alert_page_modal_body">
          <div className="alert_modal_title">{title}</div>
          <div className="alert_modal_page_body">
            <Button
              onClick={closeYes}
              disabled={false}
              id=""
              buttonName={buttonOneLabel ? buttonOneLabel :'Yes'}
              colorType={'save'}
              icon={''}
              iconPosition={''}
            />
            <Button
              onClick={closeNo}
              disabled={false}
              id=""
              buttonName={buttonTwoLabel ? buttonTwoLabel : 'No'}
              colorType={'disabled'}
              icon={''}
              iconPosition={''}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AlertPopup;